import clsx from "clsx";
import React from "react";
import { useTheme } from "../../../../../hooks";
import { Indicator } from "./EnvIndicatorStyles";
const EnvIndicator = ({ env = "", className = "", styles = {}, }) => {
    const { Theme } = useTheme();
    const DefaultStyle = { ...Theme.environment };
    const classes = clsx("best-env-indicator d-flex justify-content-center align-items-center", className);
    const CompStyles = { ...DefaultStyle, ...styles };
    switch (env) {
        case "local":
        case "dev":
        case "qa":
        case "stg":
            return (React.createElement(Indicator, { className: classes, styles: CompStyles, env: env }, env.toUpperCase()));
        case "prod":
        case "production":
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default EnvIndicator;
//# sourceMappingURL=EnvIndicator.js.map